import { createTheme } from '@mui/material/styles';
import { AppEnvSetting } from '../ts/common';

export const logoUrl = AppEnvSetting.logoURL; // 'https://logodix.com/logo/1872116.jpg';

export const backgroundUrl = ''; // 'https://images3.alphacoders.com/738/738230.jpg';
export const backgroundColor = ''; //#bb8844'; // Overrides paper color from theme for specifically the farthest back layer which the image from backgroundUrl sits atop

export const theme = createTheme({
    palette: {
        common: {
            black: '#000',
            white: '#fff'
        },
        background: {
            paper: '#fff', // This is the background color for individual items which appear over the background
            default: '#fff' // This is the background color for the main section which other elements are rendered over top of
        },
        primary: {
            main: '#09102B', // This is the main color for buttons, navigation, text boxes, and other interface elements
            contrastText: '#fff',
            // dark: '',
            // light: ''
        },
        secondary: {
            main: '#9c27b0',
            contrastText: '#fff',
            // dark: '',
            // light: ''
        },
        error: {
            main: '#d32f2f',
            contrastText: '#fff',
            // dark: '',
            // light: ''
        },
        warning: {
            main: '#ed6c02',
            contrastText: '#fff',
            // dark: '',
            // light: ''
        },
        info: {
            main: '#0288d1',
            contrastText: '#fff',
            // dark: '',
            // light: ''
        },
        success: {
            main: '#e27d32',
            contrastText: '#fff',
            // dark: '',
            // light: ''
        }
    }, // palette
    components: {
        MuiAlert: {
          styleOverrides: {
            root: ({ ownerState }) => ({
              ...(ownerState.severity === "error" &&
                ownerState.variant === "filled" && {
                  backgroundColor: "#FCEBE9",
                  color: "#751A0C",
                }),
              ...(ownerState.severity === "warning" &&
                ownerState.variant === "filled" && {
                  backgroundColor: "#FFF6E5",
                  color: "#93541B",
                }),
              ...(ownerState.severity === "info" &&
                ownerState.variant === "filled" && {
                  backgroundColor: "#E5F3FB",
                  color: "#004B6F",
                }),
              ...(ownerState.severity === "success" &&
                ownerState.variant === "filled" && {
                  backgroundColor: "#E6F9ED",
                  color: "#006730",
                }),
            }),
            icon: ({ ownerState }) => ({
              ...(ownerState.severity === "error" &&
                ownerState.variant === "filled" && {
                  color: "#751A0C",
                }),
              ...(ownerState.severity === "warning" &&
                ownerState.variant === "filled" && {
                  color: "#FFAD00",
                }),
              ...(ownerState.severity === "info" &&
                ownerState.variant === "filled" && {
                  color: "#008EDB",
                }),
              ...(ownerState.severity === "success" &&
                ownerState.variant === "filled" && {
                  color: "#0EC54F",
                }),
            }),
          },
        },
    }
})